import { useState } from "react";

/**
 * Shown on the storefront only while an admin is signed in as a customer.
 * One click puts the admin token back and returns to their profile — the
 * admin session is never dropped, it just sits in `fl_admin_token`.
 */
export const CustomerImpersonationBanner = () => {
  const [state] = useState(() => {
    try {
      const raw = localStorage.getItem("fl_impersonating_customer");
      return raw && localStorage.getItem("fl_admin_token") ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  if (!state) return null;

  const back = () => {
    const admin = localStorage.getItem("fl_admin_token");
    if (admin) localStorage.setItem("fl_token", admin);
    localStorage.removeItem("fl_impersonating_customer");
    window.location.href = `/admin/customers/${encodeURIComponent(state.email)}`;
  };

  return (
    <div className="bg-brass text-ink text-xs px-4 sm:px-6 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 sticky top-0 z-40"
         data-testid="customer-impersonation-banner">
      <span>
        Admin session — signed in as <b>{state.name || state.email}</b>. You can look around, but not place an order.
      </span>
      <button type="button" className="underline underline-offset-2 font-medium ms-auto"
              data-testid="customer-impersonation-back" onClick={back}>
        ← Back to admin
      </button>
    </div>
  );
};

export default CustomerImpersonationBanner;
